import Action, {GET, POST_FORM, POST, PUT} from "../common/Action";

export const getEventAction = new Action('GET_OPERATOR', GET, (params) => `events/${params.id}`);
export const addEventAction = new Action('ADD_OPERATOR', POST, 'events') ;
export const editEventAction = new Action('EDIT_OPERATOR', PUT, (params) => `events?id=${params.id}`) ;

export const getEvent = (id) => getEventAction.callApi(null, ({id}));
export const addEvent = (data) => addEventAction.callApi(data);
export const editEvent = (id, data) => editEventAction.callApi(data, ({id}));